/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllEnabledObjectTypeDefinitionsForPortalRpc = {
  serviceName: 'com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc',
  rpcName: 'getAllEnabledObjectTypeDefinitionsForPortal',
  auth: 'app',
  fingerprint: 'ERCeKWk3ES17BCaRR1jHaJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRpc = {
  serviceName: 'com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc',
  rpcName: 'getAllEnabledAndDisabledObjectTypeDefinitionsForPortalSorted',
  auth: 'app',
  fingerprint: 'wgUCAVeh15vgWvb1QhvIr5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSortedRpc = {
  serviceName: 'com.hubspot.blueprint.customer.object.type.rpc.CustomerObjectTypeRpc',
  rpcName: 'getAllScopeAccessibleEnabledAndDisabledObjectTypeDefinitionsForPortalSorted',
  auth: 'app',
  fingerprint: 'wgUCAVeh15vgWvb1QhvIr5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};